<template>
<div :class="`${insClass}-case`">
<ins
  :data-full-width-responsive="dataFullWidthResponsive"
  :data-ad-client="dataAdClient"
  :data-ad-slot="dataAdSlot"
  :data-ad-format="dataAdFormat"
  class="adsbygoogle"
  :class="insClass"
  :style="insStyle">
</ins>
</div>
</template>

<script>
export default {
  name: "AdUnit",
  data() {
    return {
      isLoaded: false
    };
  },
  props: {
    dataFullWidthResponsive: String,
    dataAdClient: String,
    dataAdSlot: String,
    dataAdFormat: String,
    insClass: String,
    insStyle: {
      type: String,
      default: 'display:block'
    }
  },
  methods: {
  },
  mounted() {
    if (!this.isLoaded) {
      var adsbygoogle = window.adsbygoogle || [];
      // console.log(this.dataAdSlot);
      // console.log(adsbygoogle);
      adsbygoogle.push({});
      this.isLoaded = true;
    }
  }
};
</script>

<style scoped>
.hey-delta,
.hey-delta-case {
  width: 320px;
  height: 50px;
}
@media (min-width: 480px) {
  .hey-delta,
  .hey-delta-case {
    width: 468px;
    height: 60px;
  }
}
</style>